export default __webpack_public_path__ + "aad6027c2400aae210f55bc2c45014e7.png";